var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loginOK)?_c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"toast hide",attrs:{"id":"Toast1"}}),_c('router-view')],1):_c('Loading',{attrs:{"title":"Connecting to Customer Connect"}})}
var staticRenderFns = []

export { render, staticRenderFns }